module.exports = __webpack_public_path__ + "img/4.bc2a5162.png";